import { createReducer } from 'typesafe-actions';
import { TableViewType } from '../../components';
import { setTableViewType } from './actions';

export type State = {
  transactions: TableViewType;
  accountNftTokens: TableViewType;
  accountNftCollections: TableViewType;
  contractPackageNftTokens: TableViewType;
  contractPackageOwnedNfts: TableViewType;
};
export const initialState: State = {
  transactions: TableViewType.table,
  accountNftTokens: TableViewType.secondary,
  accountNftCollections: TableViewType.secondary,
  contractPackageNftTokens: TableViewType.secondary,
  contractPackageOwnedNfts: TableViewType.secondary,
};

export default createReducer(initialState).handleAction(
  setTableViewType,
  (state, { payload }): State => ({
    ...state,
    [payload.tableId]: payload.viewType,
  })
);
